// extracted by mini-css-extract-plugin
export default {"Pill":"Pill_Pill__RcEvT","scrollBackground":"Pill_scrollBackground__juJ4H"};